import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import ar from './locales/ar.json'

export type AppLocale = 'es' | 'ar'

const RTL_LOCALES: AppLocale[] = ['ar']

// Mapea el código de idioma de Odoo (res.lang, p.ej. 'es_ES', 'ar_001') al
// locale de la PWA. El idioma manda desde el empleado: lo devuelve el onboard
// y el endpoint /status. Cualquier 'ar*' → árabe; el resto → español.
export function odooLangToLocale(odooLang?: string | null): AppLocale {
  if (odooLang && odooLang.toLowerCase().startsWith('ar')) return 'ar'
  return 'es'
}

// Idioma para la Web Speech API (dictado por voz del MicButton).
export function speechLang(locale: AppLocale): string {
  return locale === 'ar' ? 'ar-SA' : 'es-ES'
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'es',
  fallbackLocale: 'es',
  messages: { es, ar },
})

// Aplica el idioma a vue-i18n y ajusta dir/lang del documento. El árabe es RTL
// (de derecha a izquierda): ponemos dir="rtl" en <html> para que el layout y el
// texto se reflejen.
export function applyLocale(locale: AppLocale) {
  i18n.global.locale.value = locale
  const html = document.documentElement
  html.setAttribute('lang', locale)
  html.setAttribute('dir', RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr')
}

// Atajo: aplica el idioma a partir del código de Odoo del empleado.
export function applyOdooLang(odooLang?: string | null) {
  applyLocale(odooLangToLocale(odooLang))
}

// Locale activo actual (para componentes que necesitan, p.ej., el idioma de voz).
export function currentLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale
}
